import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle, Mail } from 'lucide-react';
const faqs = [{
  q: 'Wie schnell kann ich mit Ergebnissen rechnen?',
  a: 'Die meisten Anwender berichten von ersten Verbesserungen nach 2–3 Wochen regelmäßiger Einnahme. Für optimale Ergebnisse empfehlen wir eine Anwendung über mindestens 8–12 Wochen, da pflanzliche Wirkstoffe Zeit brauchen, um ihre volle Wirkung zu entfalten.'
}, {
  q: 'Ist UroNacht sicher? Gibt es Nebenwirkungen?',
  a: 'UroNacht enthält ausschließlich natürliche, gut erforschte Inhaltsstoffe in Dosierungen, die in klinischen Studien als sicher eingestuft wurden. Nebenwirkungen sind selten. Wenn Sie verschreibungspflichtige Medikamente einnehmen, sprechen Sie bitte vorab mit Ihrem Arzt.'
}, {
  q: 'Kann ich UroNacht zusammen mit meinen anderen Medikamenten nehmen?',
  a: 'UroNacht ist ein Nahrungsergänzungsmittel und in der Regel gut verträglich. Bei gleichzeitiger Einnahme von Blutverdünnern oder Hormonpräparaten empfehlen wir, Ihren Arzt oder Apotheker zu konsultieren.'
}, {
  q: 'Warum 3 Kapseln pro Tag?',
  a: 'Die hohe Dosierung von 640 mg Sägepalme und 360 mg Brennnessel lässt sich nicht in eine einzelne Kapsel pressen, ohne die Wirkstoffqualität zu kompromittieren. Drei Kapseln garantieren die volle therapeutische Dosis ohne Füllstoffe.'
}, {
  q: 'Was ist, wenn es bei mir nicht wirkt?',
  a: 'Wir sind von UroNacht überzeugt. Sollten Sie innerhalb von 60 Tagen nicht zufrieden sein, erhalten Sie Ihr Geld zurück — ohne Wenn und Aber.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-28 md:py-32 bg-white text-slate-900" data-id="element-81">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="text-center mb-20" data-id="element-83">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-500 font-bold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-84"></motion.span>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex items-center justify-center gap-3 mb-6" data-id="element-85">
            <HelpCircle className="w-8 h-8 text-brand-500" data-id="element-86" />
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-87">
              Häufig gestellte Fragen
            </h2>
          </motion.div>
        </div>

        <div className="space-y-4 mb-16" data-id="element-88">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-89">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className={`w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none group transition-colors duration-300 ${openIndex === index ? 'bg-brand-50/50' : 'bg-white'}`} aria-expanded={openIndex === index} data-id="element-90">
                <div className="flex items-center gap-6" data-id="element-91">
                  <span className="text-slate-300 font-serif font-bold text-2xl hidden md:block" data-id="element-92">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="font-bold text-lg md:text-xl text-slate-900 group-hover:text-brand-600 transition-colors" data-id="element-93">
                    {faq.q}
                  </span>
                </div>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors duration-300 ${openIndex === index ? 'bg-brand-100 text-brand-500' : 'bg-slate-100 text-slate-400'}`} data-id="element-94">
                  <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-95" />
                </div>
              </button>
              <AnimatePresence data-id="element-96">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-97">
                    <div className="px-6 md:px-8 pb-8 pl-6 md:pl-20 text-slate-600 leading-loose text-base bg-brand-50/50" data-id="element-98">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-99">
          <p className="text-slate-500 flex items-center justify-center gap-2" data-id="element-100">
            <Mail className="w-4 h-4" data-id="element-101" />
            Weitere Fragen? Schreiben Sie uns an{' '}
            <a href="mailto:support@uronacht.de" className="text-brand-500 hover:underline font-medium" data-id="element-102">
              support@uronacht.de
            </a>
          </p>
        </div>
      </div>
    </section>;
}